import { UserRole } from '@hms/shared';

/** Names of the stock request routes (CORA-417), shared by the router and the screens that link to them. */
export const StockRequestRoute = {
  List: 'WarehouseStockRequests',
  New: 'WarehouseStockRequestNew',
  Detail: 'WarehouseStockRequestDetail',
} as const;
export type StockRequestRoute = (typeof StockRequestRoute)[keyof typeof StockRequestRoute];

/** The organization stock page (CORA-417). */
export const STOCK_AVAILABILITY_ROUTE = 'WarehouseStockAvailability';

// The roles of the /stock-requests API: the hospital side requests, the central site decides and ships.
export const STOCK_REQUEST_ROLES: string[] = [UserRole.ADMIN, UserRole.HOSPITAL_ADMIN, UserRole.STOCK_MANAGER, UserRole.CENTRAL_STOCK_MANAGER];

// The roles of the /stock-availability API (Andre, A3 and P3); doctors, nurses and reception get none.
export const STOCK_AVAILABILITY_ROLES: string[] = [UserRole.ADMIN, UserRole.HOSPITAL_ADMIN, UserRole.STOCK_MANAGER, UserRole.CENTRAL_STOCK_MANAGER];
